import React from 'react';
import { BaseEdge, getSmoothStepPath } from 'reactflow';

const RoundedStepEdge = (props) => {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    markerEnd,
    style,
  } = props;

  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    borderRadius: 12,
    offset: 0,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
      {/* Wider invisible stroke for easier hover/selection */}
      <path d={edgePath} fill="none" stroke="transparent" strokeWidth={10} className="react-flow__edge-interaction" />
    </>
  );
};

export default RoundedStepEdge;

